import { render, staticRenderFns } from "./model_select_dropdown.vue?vue&type=template&id=0b5e11f6"
import script from "./model_select_dropdown.vue?vue&type=script&lang=js"
export * from "./model_select_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports